import createSlots from '../utils/create-slots'

export const {Slots, Slot} = createSlots(['Caption', 'Input', 'Label', 'LeadingVisual'])
